import * as React from 'react';

const ProgressBlockContainer = ({
    children,
}: IProgressBlockContainer) => (
    <div className="sitegen-friend-referral-progress-block-container">
        { children }
    </div>
);

export interface IProgressBlockContainer {
    readonly children: React.ReactNode;
}

export default ProgressBlockContainer;
